import { render, staticRenderFns } from "./CitatuonArticle.vue?vue&type=template&id=49a5b6bf&scoped=true"
import script from "./CitatuonArticle.vue?vue&type=script&lang=js"
export * from "./CitatuonArticle.vue?vue&type=script&lang=js"
import style0 from "./CitatuonArticle.vue?vue&type=style&index=0&id=49a5b6bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a5b6bf",
  null
  
)

export default component.exports